import { useEffect, useState } from "react"
import { Promotions } from "../../Objects/Promotion/Promotions"
import { EGenderType } from "../../Enum/EGenderType"
import { EEnableStatusType } from "../../Enum/EEnableStatusType"
import i18next from "i18next"
import { type ValidationError } from "../../Objects/Generics/Helps"
import { EDayOfWeek } from "../../Enum/EDayOfWeek"

export const useCreatePromotions = (promotionBase: Promotions | null | undefined) => {
  const [name, setName] = useState("")

  const [description, setDescription] = useState("")

  const [percentagemDiscount, setPercentagemDiscount] = useState("")

  const [dayWeek, setDayWeek] = useState<EDayOfWeek[]>([0, 1, 2, 3, 4, 5, 6])

  const [GenderType, setGender] = useState<EGenderType>(EGenderType.All)

  const [timeStart, setTimeStart] = useState("")

  const [timeFinish, setTimeFinish] = useState("")

  const [coastFixed, setCoastFixed] = useState("")

  const [status, setStatus] = useState<EEnableStatusType>(EEnableStatusType.Active)

  const [promotions, setPromotions] = useState<Promotions | null>(null)

  const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => setName(e.target.value)
  const handleDescriptionChange = (e: React.ChangeEvent<HTMLInputElement>) => setDescription(e.target.value)
  const handlePercentagemDiscountChange = (e: React.ChangeEvent<HTMLInputElement>) =>
    setPercentagemDiscount(e.target.value)
  const handleDayWeekChange = (e: EDayOfWeek[]) => setDayWeek(e)
  const handleTimeFinishChange = (e: string) => setTimeFinish(e)
  const handleTimeStartChange = (e: string) => setTimeStart(e)
  const handleCoastFixedChange = (e: React.ChangeEvent<HTMLInputElement>) => setCoastFixed(e.target.value)
  const handleGenderChange = (e: React.ChangeEvent<HTMLSelectElement>) =>
    setGender(e.target.selectedIndex as EGenderType)
  const handleStatusChange = (e: React.ChangeEvent<HTMLSelectElement>) =>
    setStatus(e.target.selectedIndex as EEnableStatusType)

  useEffect(() => {
    handleInitialValue(promotionBase)
  }, [promotionBase])

  const handleInitialValue = (promotions: Promotions | null | undefined) => {
    if (promotions) {
      setPromotions(promotions)
      setName(promotions.name)
      setDescription(promotions.description)
      setPercentagemDiscount(promotions.percentage.toString())
      setDayWeek(promotions.dayOfWeek)
      setGender(promotions.genderType)
      setTimeFinish(promotions.endTime)
      setTimeStart(promotions.startTime)
      setStatus(promotions.status)
      setCoastFixed(promotions.fixedValue.toString())
    }
  }

  const handleSubmitForm = (): Promotions | { errors: ValidationError[] } => {
    const errors: ValidationError[] = []

    if (name.trim().length === 0) {
      errors.push({ field: i18next.t("promotion:field_name"), message: i18next.t("promotion:error_name_required") })
    }

    if (dayWeek.length === 0) {
      errors.push({ field: i18next.t("promotion:field_days"), message: i18next.t("promotion:error_day_required") })
    }

    if (
      (percentagemDiscount === "0.00" || percentagemDiscount.length === 0) &&
      (coastFixed === "0" || coastFixed.length === 0)
    ) {
      errors.push({
        field: i18next.t("promotion:field_discount_type"),
        message: i18next.t("promotion:error_discount_required"),
      })
    }

    if (errors.length > 0) {
      return { errors }
    }

    return new Promotions({
      id: promotions?.id,
      name: name,
      percentage: Number(percentagemDiscount),
      dayOfWeek: dayWeek,
      description: description,
      genderType: GenderType,
      startTime: timeStart,
      endTime: timeFinish,
      fixedValue: Number(coastFixed),
      status: status,
    })
  }

  return {
    name,
    description,
    percentagemDiscount,
    dayWeek,
    timeStart,
    timeFinish,
    GenderType,
    coastFixed,
    status,
    handleNameChange,
    handleDescriptionChange,
    handlePercentagemDiscountChange,
    handleDayWeekChange,
    handleTimeFinishChange,
    handleTimeStartChange,
    handleStatusChange,
    handleGenderChange,
    handleCoastFixedChange,
    handleSubmitForm,
    handleInitialValue,
  }
}
